import { Button } from 'antd';
import React from 'react';
import history from '../../routes/history';
import { LoadingOutlined } from '@ant-design/icons';

const ChooseGigsButton = ({ talentName=false,MessageEditsection, backHandler, nextHandler, selectedGigDetails, path, ConversationId, SkillListingId,nextButton='Next',nextLoading=false }) => {
    function routesLink() {
        if (MessageEditsection){
            history.push(`/conversations/${ConversationId[0]?.ConversationId}`)
        } else if (path == "/editPlaceBidPage"){
            history.push(`/profiledetail/${SkillListingId}`)
        }else{
            backHandler();
        }
    }
    return (
        <div className="modalFooterPB">
            <button
                key="back"
                className="backBtnPlaceBid centerElement textPlaceBid"
                onClick={routesLink}
            >
                Back  {talentName ? `to ${talentName}` : null}
            </button>
            <button
                style={{
                    border: "none",
                }}
                className={`nextBtnPlacedBid nextBtnPlaceBid-nextPadding centerElement textPlacedBid ${selectedGigDetails ? "" : "disable-next-btn-pvt"}`}
                disabled={nextLoading}
                onClick={ selectedGigDetails ? nextHandler : null}
            >
                {nextButton }{nextLoading ? <LoadingOutlined style={{marginLeft:"4px"}} />:undefined} 
            </button>
        </div>
    );
};

export default ChooseGigsButton;